import Button from "../Button";

export type ModalProps = {
    title: string;
    message: string;
    onClose: () => void;
};

export default function Modal({ title, message, onClose }: ModalProps) {
    return (
        <>
            <div
                className="modal fade show"
                style={{ display: 'block' }}
                tabIndex={-1}
                aria-modal="true"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content text-center p-4">
                        <div className="modal-body py-4">
                            <div className="text-success mb-3">
                                <i className="fas fa-check-circle" style={{ fontSize: '4rem' }} />
                            </div>
                            <h5 className="mb-2">{title}</h5>
                            <p className="text-muted mb-0">
                                {message}
                            </p>
                        </div>
                        <div className="modal-footer border-0 justify-content-center pb-4">
                            <Button
                                type="button"
                                className="btn btn-primary"
                                onClick={onClose}
                            >
                                Tamam
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" />
        </>
    )
}